import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'

import Info from '../Info'

import classes from './Header.module.scss'

/** @type {import("./types").default} */
const Header = ({
  listing,
  children,
  variant,
  allowWriteReview,
  component,
  listingPosition = 0,
  enableBuyerIntent = false,
}) => {
  return (
    <Grid data-testid="listing-item_header" container className={clsx('Header', classes.root)}>
      <Grid item xs>
        <Info
          variant={variant}
          allowWriteReview={allowWriteReview}
          enableBuyerIntent={enableBuyerIntent}
          listing={listing}
          component={component}
          listingPosition={listingPosition}
        />
      </Grid>
      {children && (
        <Grid item sm={4} xs={12} className={classes.buttons}>
          {children}
          <div role="separator" className={classes.ctaBorder} />
        </Grid>
      )}
    </Grid>
  )
}

export default Header
